import { TypeUtils } from '@vectord/utils';

export default function parseCoursePauseRequest({
  currentPage,
  filters,
  sortOrder,
  coursePauseType,
  resumeDate = null,
  coursePauseStatus,
}) {
  const {
    learnerEmail,
    currentBatch,
    newBatch,
    pauseDuration,
    courseType,
    fromToBeResumedDate,
    untilToBeResumedDate,
  } = filters;
  const { field, type } = sortOrder;

  let formattedFromToBeResumedDate;
  if (TypeUtils.isPresent(fromToBeResumedDate)) {
    formattedFromToBeResumedDate = new Date(fromToBeResumedDate).toDateString();
  }

  let formattedUntilToBeResumedDate;
  if (TypeUtils.isPresent(untilToBeResumedDate)) {
    formattedUntilToBeResumedDate = new Date(
      untilToBeResumedDate
    ).toDateString();
  }

  let email;
  if (TypeUtils.isPresent(learnerEmail)) {
    email = learnerEmail;
  }

  return {
    page: currentPage,
    sortOrder: {
      field: field || 'created_at',
      type: type || 'desc',
    },
    coursePauseType,
    coursePauseStatus,
    filters: {
      learnerEmail: email,
      currentBatch: currentBatch?.value,
      newBatch: newBatch?.value,
      pauseDuration: pauseDuration?.value,
      courseType: courseType?.value,
      resumeDate: resumeDate,
      fromToBeResumedDate: formattedFromToBeResumedDate,
      untilToBeResumedDate: formattedUntilToBeResumedDate,
    },
  };
}
